

















































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import SharedContentList from "@/components/shared-content/SharedContentList.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction, IAlert, IChips } from "@/components/utility/mmmint/MHeader.vue";
import SelectEntity from "@/components/utility/SelectEntity.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { RepairEstimateGoToHelper } from "@/lib/utility/repair-estimate.go-to-helper";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { IReport, Report } from "@/models/report.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import ActivityCard from "../thg/ActivityCard.vue";
import RepairEstimateSheet from "./RepairEstimateSheet.vue";

@Component({
  components: {
    LatestEntriesCardEmpty,
    RepairEstimateSheet,
    MHeader,
    MDetailViewGrid,
    ActivityCard,
    SharedContentList,
    SelectEntity
  }
})
export default class RepairEstimateDetail extends mixins(PartnerFallbackMixin, PermissionMixin) {
  @Prop()
  value!: IRepairEstimate;

  @Prop({ type: Boolean })
  showDetailButton!: boolean;

  @Prop({ type: Boolean })
  hideBreadCrumbs!: boolean;

  @PropSync("loading", { type: Boolean })
  isLoading!: boolean;

  report?: IReport | null = null;

  get title() {
    return this.value?.number || $t(`enums.RequestStatusEnum.${this.value.status}`);
  }

  get alerts(): IAlert[] {
    const alerts: IAlert[] = [];

    return alerts;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      key: "createdReadable",
      text: this.value.timestamp.createdReadable
    });

    chips.push({
      text: $t(`enums.RequestStatusEnum.${this.value.status}`),
      color: this.value.statusColor,
      key: "updatedReadable"
    });

    if (this.value.subTotal) {
      chips.push({
        text: formatCurrency(this.value.subTotal, this.value.currency),
        color: "success",
        key: "subTotal"
      });
    }

    if (this.value.status !== RequestStatusEnum.REPLIED && this.value.date) {
      chips.push({
        text: `${$t("repairEstimate.untilWhen")} ${simpleDoubleDigitDate(this.value.date)}`,
        color: "success",
        key: "date"
      });
    }
    return chips;
  }

  get refsCategories(): BackendResourceEnum[] {
    return this.value.refsCategories;
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const breadCrumbs = RepairEstimateGoToHelper.breadCrumbs;

    const selected = [];

    selected.push(breadCrumbs.RepairEstimateTable(this.value.partnerId));
    selected.push(breadCrumbs.RepairEstimateDetail(this.value.partnerId, this.value.id));

    return selected;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new RepairEstimateGoToHelper(this.$router).goToRepairEstimateDetail({
            partnerId: this.value.partnerId,
            repairEstimateId: this.value.id,
            newTab: false
          })
      });
    }

    return actions;
  }

  get bottomActions() {
    const actions: IAction[] = [];

    return actions;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.REPAIR_ESTIMATE
    };
  }

  get to() {
    if (this.value.seller?.email) {
      return [this.value.seller.email];
    }
    return [];
  }

  async updateReportId(reportId: string | null) {
    try {
      await this.value.updatePartial({ reportId: reportId });
      if (this.value.reportId) {
        this.report = await new Report({
          id: this.value.reportId,
          partnerId: this.value.partnerId
        }).fetch();
      } else {
        this.report = null;
      }
    } catch (error) {
      handleError(error);
    }
  }

  @Watch("value.id", { immediate: true })
  async fetchData() {
    try {
      if (!this.value || !this.value.id || !this.value.partnerId) {
        return;
      }
      this.isLoading = true;

      await this.value.fetch();
      await this.value.fetchDocument();
      await this.value.fetchSharedContent();

      if (this.value.reportId) {
        this.report = await new Report({
          id: this.value.reportId,
          partnerId: this.value.partnerId
        }).fetch();
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }
}
